import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";
import { PdmVersaoEntity, SolicitacaoProcessamentoEntity } from '@catalogo/models';
import { ApiResult, CrudService } from 'ui-shared';

@Injectable({ providedIn: 'any' })
export class PdmVersaoDataService extends CrudService<any> {

    protected url: string;
    protected baseUrl: string;
    protected urlPdm: string;

    constructor(
        @Inject(OPERACAO_API_URL) urlBase: string,
        @Inject(HttpClient) protected httpClient: HttpClient
    ) {
        super(urlBase, httpClient);

        this.url = `${urlBase}/v1/pdm/<parent>/versao`;
        this.baseUrl = this.url;
        this.urlPdm = `${this.baseUrl}/v1/pdm`;
    }

    public withParentId(pdmId: string) {
        this.url = this.baseUrl.replace('<parent>', pdmId);
        return this;
    }

    public adicionarRetificacao(pdmId: string, versaoId: string) {
        this.url = this.baseUrl.replace('<parent>', pdmId) + "/" + versaoId + "/retificacao";
        return this;
    }
    public ativarInativar(pdmId: string, versaoId: string) {
        this.url = this.baseUrl.replace('<parent>', pdmId) + "/" + versaoId + "/ativar" ;
        return this;
    }

    public getMaiorVersao = () => {
        return this.httpClient.get<ApiResult<PdmVersaoEntity>>(this.url.replace("/versao","/maiorversao"));
    }
    
    public obterUltimaSolicitacaoGerarNovaVersao = () =>
        this.httpClient.get<ApiResult<SolicitacaoProcessamentoEntity>>(`${this.url}/GerarNovaVersao/Atual`);
}
